(function () {
    var path = decodeURIComponent(location.pathname);
    if(path !== '/search') return;
    if(!location.search || location.search.charAt(0) !== '?') return;

    var excl = ['-product_type:PD-Custom-Product', '-product_type:hideme'];
    var search = decodeURIComponent(location.search.substring(1));
    var params = search.split('&');
    var redirect = false;
    var par_hash = {}
    params.forEach(function(p) {
        var v = p.split('=');
        par_hash[v[0]] = v[1] || null;
    });
    if(!('q' in par_hash)) return;

    var parts = par_hash.q.split('+');
    excl.forEach(function(e) {
        if(parts.indexOf(e) === -1) {
            parts.push(e);
            redirect = true;
        }
    });
    par_hash.q = parts.join('+');

    if(!par_hash.type || (par_hash.type !== 'product')) {
        par_hash.type = 'product';
        redirect = true;
    }

    params = [];
    for(var par in par_hash) {
        var s;
        if(par_hash[par] === null) s = par;
        else s = par + '=' + par_hash[par];
        params.push(s);
    }
    var new_search = params.join('&');
    if(redirect)
        location.search = '?' + new_search;
}) ();
